import React, {useEffect, useState} from 'react'
import { Link } from 'react-router-dom';
import axios from 'axios';

function Login({show, onClose, onSwitchToSignUp, onSwitchToForgotPassword}) {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [admin, setAdmin] = useState();

    axios.defaults.withCredentials = true;

    const clearFields = () => {
        setEmail('');
        setPassword('');
        setErrorMessage('');
        setAdmin('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(!email || !password){
            setErrorMessage('Please fill all fields');
            return;
        }

        try {
            console.log("Attempting login with password:", password);

            const result = await axios.post('http://localhost:3001/login', {email, password}, {
                withCredentials: true
            });
            console.log("Login response:", result.data);
            console.log("Login Role:", result.data.role);
            
            if(result.data.status === "Success") {

                localStorage.setItem('token', result.data.token);
                clearFields();
                onClose();
            // if(result.data.user.role === 'admin') {
            //     window.location.href = '/admin';
            // } else {
            //     window.location.href = '/home';
            // }
            const redirectPath = result.data.user.role === 'admin' 
            ? '/admin' 
            : '/home';
      
            window.location.href = redirectPath;
            } else {
                setErrorMessage(result.data.message || "Login failed");
            }
        } catch (error) {
            console.error("Login error:", error);
            setErrorMessage(error.response?.data?.message || "Login failed. Please try again.");
        }

    };

    useEffect(() => {
        if(show) {
            const resetToken = localStorage.getItem('resetToken');
            if(resetToken) {
                console.warn("Reset token still exists in localStorage during login")
            }
        }
    }, [show]);
    
    const handleClose = () => {
        clearFields();
        onClose();
    };


    const handleSwitchToSignUp = () => {
        clearFields();
        onClose();
        onSwitchToSignUp();
    }

    const handleShowResetPassword = () => {
        onClose();
        window.dispatchEvent(new CustomEvent("showResetPassword"));
    };

    return (
        <div className="auth-modal-overlay" style={{ display: show ? 'flex' : 'none' }}>
          <div className="auth-modal-content">
            <span className="auth-close-btn" onClick={handleClose}>&times;</span>
            <h2 className="auth-modal-title">TATA CLiQ FASHION</h2>
    
            <div className='bg-white p-3 rounded w-250'>
                    <h2>Login</h2>
                    {errorMessage && <div className='alert alert-danger'>{errorMessage}</div>}
                        <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="email"><strong>Email</strong></label>
                                    <input type="email" 
                                    value={email}
                                    className='form-control rounded-0'
                                    onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="email"><strong>Password</strong></label>
                                    <input type="password" 
                                    value={password}
                                    className='form-control rounded-0'
                                    onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <button type='submit' className='btn btn-success w-100 rounded-0'>Login</button>
                        </form>
                        <br />
                        <p>Don't have an Account?</p>
                        <button type='submit' className='btn btn-primary w-100 rounded-0'
                        onClick={() => {
                            handleSwitchToSignUp();
                          }}
                          >Sign Up</button>
                            <div className="text-end py-2">
                                <Link 
                                style={{cursor: 'pointer'}}
                                onClick={(e) => {
                                    e.preventDefault();
                                    onSwitchToForgotPassword();
                                    // handleShowResetPassword();
                                }}
                                >Forgot Password?</Link>
                            </div>
            </div>
          </div>
        </div>
      )
}

export default Login